module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "figcenter1"
  }, [_c('img', {
    staticClass: "calibre16",
    attrs: {
      "alt": "Frontispiece",
      "id": "id-2208187964854764959",
      "src": "Images/img0009.jpg",
      "title": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption0"
    }
  }, [_vm._v("the pursuit of the train robber.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0